import React, { useEffect } from 'react';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';

import {
    selectShowEditor,
} from '~Betslip/selectors/userMultiplesSelectors';

import {
    toggleEditor,
} from '~Betslip/slices/userMultiplesSlice';

import AddBet from './AddBet';
import MultipleEditor from './MultipleEditor';
import MultiplesList from './MultiplesList';

import './multiples-builder.scss';

const MultiplesBuilder = () => {
    const dispatch = useDispatch();
    const showEditor = useSelector(selectShowEditor);

    useEffect(() => {
        return () => {
            dispatch(toggleEditor());
        };
    }, []);

    return (
        <div className="fullslip__multiples-builder">
            {showEditor
                ? <MultipleEditor />
                : <AddBet />
            }
            <MultiplesList />
        </div>
    );
};

export default MultiplesBuilder;
